import bannerImg from '../../../assets/Vinyl.png';

const BannerSection = () => {
  return (
    <div className="w-full flex justify-center bg-[#fff] py-12">
      <div className="w-full max-w-[1174px] px-4 md:px-0">
        <div className="w-full min-h-[320px] md:min-h-[380px] relative overflow-hidden shadow-lg bg-[#f6f3ff] flex items-center justify-center">
          <img
            src={bannerImg}
            alt="SACIT Symposium 2025 Banner"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
